// extracted by mini-css-extract-plugin
module.exports = {"underlinedLink":"UnderlinedLink_underlinedLink__oFqpm"};